type Props = { size?: number; color?: string };

export function IconMapPin({ size = 18, color = "currentColor" }: Props) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokeWidth="1.8"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
		>
			<path d="M12 21s7-6.1 7-12a7 7 0 1 0-14 0c0 5.9 7 12 7 12z" />
			<circle cx="12" cy="9" r="2.4" />
		</svg>
	);
}
